export function scrollTo(
    element: HTMLElement | null,
    offset: number = 0,
    options: ScrollToOptions = {},
    container: HTMLElement | null | string | boolean = null,
): void {
    if (!element) return;

    const defaultOptions: ScrollToOptions = {behavior: "smooth"};
    const scrollOptions: ScrollToOptions = {...defaultOptions, ...options};

    let containerElement: HTMLElement | null = null

    if (container) {
        if (container instanceof HTMLElement) {
            containerElement = container
        } else if (typeof container === 'string') {
            containerElement = element.closest(container)
        } else {
            containerElement = element.closest('.scroll')
        }
    }

    if (containerElement) {
        const elementRect = element.getBoundingClientRect();
        const containerRect = containerElement.getBoundingClientRect();

        // Положение элемента относительно контейнера
        const relativeTop = elementRect.top - containerRect.top;

        // Текущая прокрутка контейнера + относительное положение элемента
        const scrollTop = containerElement.scrollTop + relativeTop - offset;

        containerElement.scrollTo({
            top: scrollTop,
            ...scrollOptions,
        });
    } else {
        const elementPosition = element.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({
            top: elementPosition - offset,
            ...scrollOptions,
        });
    }
}
